<template>
  <div>
    
    <template>
      <div v-if="selectedId != null">
        <a @click="openNewOrg" role="button" class="tx-brand-01">{{
          fld.cstmFld2
        }}</a>
        <span
          class="btn btn-danger btn-xs text-white pd-0 btn-uppercase mg-l-5"
          style="margin-top: -20px;"
          role="button"
          @click="emitNull"
        >
          <feather type="x"></feather>
        </span>
      </div>

      <button
        @click="openNewOrg"
        v-else
        type="button"
        class="btn btn-xs btn-outline-primary btn-block"
      >
        сонгоно уу...
      </button>

      <!-- <button
        @click="showFinder"
        v-else
        type="button"
        class="btn btn-xs btn-outline-primary btn-block"
      >
        сонгоно уу...
      </button> -->
    </template>

    <b-modal v-model="finderShow" size="xl" title="Байгууллага" scrollable centered no-close-on-backdrop>
    <!-- {{ project.title }} -->
      <div style="min-height: 70vh">
        <table class="table table-striped wd-100p">
          <thead>
            <tr>
              <th class="wd-50">№</th>
              <th class="wd-100 ">Регистр</th>
              <th>Нэр</th>
              <th class="wd-100">-</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(t,i) in tasksFilter" :key="i">
              <td>{{ i+1 }}</td>
              <td class="font-weight-bold">{{ t.prefix }}</td>
              <td>{{ t.task }}</td>
              <td>
                <button @click="handleTask(t)" class="btn btn-xs btn-primary">сонгох</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <template #modal-footer>
        <div class="wd-100p d-flex justify-content-between">
          <div>
            <div class="input-group">
              <input v-model="textSearch" placeholder="Хайх ..." type="text" class="form-control">
              <button @click="textSearch='' " class="btn btn-secondary" type="button">
                Бүх байгууллага <span v-show="tasksFilter.length!=tasks.length">{{ tasksFilter.length }}/{{ tasks.length }}</span>
              </button>
            </div> 
          </div>
          <div>
            <a @click="openNewOrg()" class="btn btn-secondary">Байгууллага бүртгэх</a>
          </div>
          <b-button
            variant="warning"
            size="sm"
            class=""
            @click="finderShow=false"
          >
            Хаах
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal v-model="newOrg.modal" title="Сонгоно уу" centered hide-footer size="md" no-close-on-backdrop scrollable>
      <!-- <template #modal-header>
      
        <Tabs v-model="activeName" >
          <TabPane label="User" name="first"></TabPane>
          <TabPane label="Config" name="second"></TabPane>
        </Tabs>
      </template> -->

      
      <div class="bd-b bd-2 bd-primary mg-b-20 pd-b-5">
        <Radio v-model="radio" label="1">Байгууллага</Radio>
        <Radio v-model="radio" label="2">Хувь хүн</Radio>
        <!-- <Radio v-model="radio" label="3">Шинэ байгууллага</Radio> -->
        <!-- <div class="el-tabs el-tabs--top">
          <div role="tablist" class="el-tabs__nav is-top" style="transform: translateX(0px);">
            <div class="el-tabs__active-bar is-top" style="width: 30px; transform: translateX(0px);"></div>
            <div id="tab-first" aria-controls="pane-first" role="tab" tabindex="0" class="el-tabs__item is-top is-active" aria-selected="true">User</div><div id="tab-second" aria-controls="pane-second" role="tab" tabindex="-1" class="el-tabs__item is-top">Config</div>
          </div>
          <div class="el-tabs__content"><div role="tabpanel" id="pane-first" aria-labelledby="tab-first" class="el-tab-pane" style=""></div><div role="tabpanel" id="pane-second" aria-labelledby="tab-second" class="el-tab-pane" style="display: none;" aria-hidden="true"></div>
          </div>
        </div> -->
      </div>
      <template v-if="radio=='1'">
        <Form label-position="left" label-width="150px">
          <FormItem label="Байгууллагын регистр">
            <Input v-model="newOrg.regno">
              <!-- <Button @click.prevent="fetchNewOrg" slot="append" icon="el-icon-search"></Button> -->
              <a @click.prevent="fetchNewOrg"  role="button" slot="append" class="el-button el-button--submit">
                <i class="el-icon-search"></i>
              </a>
            </Input>
          </FormItem>
          <FormItem v-if="newOrg.fetched" label="Байгууллагын нэр">
            <Input v-model="newOrg.name" disabled />
          </FormItem>
          <!-- <FormItem v-if="newOrg.fetched" label="Байгууллагын хэлбэр">
            <loc-type-cascader
                :id.sync="newOrg.type"
                v-model="newOrg.type"
                :getParentType="true"
                :checkStrictly="true"
                locTypekey="stptpCRM"
                :disabled="false"
                disableAdd
              />
          </FormItem> -->
          <FormItem v-if="newOrg.fetched">
            <Divider class="lh-1">Холбоо барих мэдээлэл</Divider>
          </FormItem>
          <FormItem v-if="newOrg.fetched" label="Утасны дугаар"><Input v-model="newOrg.cphone" /></FormItem>
          <FormItem v-if="newOrg.fetched" label="И-мэйл"><Input v-model="newOrg.cmail" /></FormItem>
          <FormItem v-if="newOrg.fetched" label="Захирлын нэр"><Input v-model="newOrg.cname" /></FormItem>
          <FormItem v-if="newOrg.fetched" label="Захирлын утас"><Input v-model="newOrg.cmobile" /></FormItem>
          <FormItem v-if="newOrg.fetched" label="Хаяг"><Input v-model="newOrg.caddress" type="textarea" :rows="2" /></FormItem>
          <FormItem v-if="newOrg.fetched" label="Холбоо барих боломжгүй үед холбоо барих төсөлд оролцогч"><Input v-model="newOrg.langCode" /></FormItem>
          <FormItem v-if="newOrg.fetched" label="Байршил">
            <loc-type-cascader
                :id.sync="newOrg.location"
                v-model="newOrg.location"
                :getParentType="true"
                :checkStrictly="true"
                locTypekey="stptpCRMLocation"
                :disabled="false"
                disableAdd
              />
          </FormItem>
          <FormItem v-if="newOrg.fetched">
            <Divider class="lh-1">Бусад</Divider>
          </FormItem>
          <FormItem v-if="newOrg.fetched" label="Байгуулагдсан огноо">
            <DatePicker
              v-model="newOrg.d1"
              type="date"
              placeholder="Select date"
              style="width: 100%"
              :format="'yyyy-MM-dd'"
              :value-format="'yyyy-MM-dd'"
            ></DatePicker>
          </FormItem>
          <FormItem v-if="newOrg.fetched" label="Өөрчлөн байгуулагдсан эсэх">
            <Checkbox v-model="newOrg.isTender"></Checkbox>
          </FormItem>
          <FormItem v-if="newOrg.fetched" label="Товч танилцуулга"><Input v-model="newOrg.taskDesc" type="textarea" :rows="2" /></FormItem>
          <FormItem v-if="newOrg.fetched" label="Лого">
            <simple-uploader
                
                :propObjectId="6"
                :propObjectTypeId="6"
                @on-success="fileUploaded"
                class="wd-100 v4upldr"
                propAccept="image/png, image/jpeg, image/jpg, image/bmp"
              >
                <div slot="trigger" class="wd-100 ht-100 rounded-circle">
                  <a
                    v-if="
                    newOrg.defaultAttachmentId == 0 ||
                    newOrg.defaultAttachmentId == null
                    "
                    class="dropdown-item"
                    >Энд дарж зураг оруулна уу.</a
                  >
                  <div v-else class="pos-relative">
                    <div class="">
                      <img :src="`${newOrg.uploadedUrl}`" class="rounded-circle wd-100 ht-100" alt />
                    </div>
                    <div class="pos-absolute l-35 b-5 btn btn-icon btn-xs btn-primary rounded-circle">
                        <feather type="camera" class="tx-white"></feather>
                    </div>
                  </div>
                </div>
              </simple-uploader>
          </FormItem>
        </Form>
        <div class="text-center mg-t-10" v-if="newOrg.fetched">
          <a @click="chooseNewOrg()" class="btn btn-success">Хадгалах</a>
        </div>
        <div v-else class="alert alert-info" role="alert">
          <h4 class="alert-heading">Санамж !</h4>
          <p>Байгууллагын регистрийн дугаараа оруулаад хайх дарна уу<br/><br/> Регистрийн дугаараар байгууллагын мэдээлэл олдоогүй тохиолдолд ШУТсанд хандана уу</p>
        </div>
      </template>
      <template v-else-if="radio=='2'">
        <Form label-position="left" label-width="150px">
          <FormItem label="Овог">
            <Input v-model="newPerson.taskEn" />
          </FormItem>
          <FormItem label="Нэр">
            <Input v-model="newPerson.task" />
          </FormItem>
          <FormItem label="Иргэний бүртгэлийн дугаар">
            <Input v-model="newPerson.prefix" />
          </FormItem>
          <div class="alert alert-secondary">
            <div class="lh-1 pd-l-10 mg-l-10 mg-y-5 bd-l bd-2 bd-gray-400 bd-white tx-italic">Доорхи аргуудын аль нэгээр иргэний бүртгэлийн дугаараа мэдэх боломжтой</div>
            <div class="pos-relative pd-l-30">
              <ul>
              <li>Иргэний үнэмлэхний QR уншуулах</li>
              <li class="lh-1">e-Mongolia цахим системээс /бүртгэлийн дугаар/</li>
              <li class="lh-1">И-баримт апп-с /ТТД эсвэл Иргэний код/</li></ul>
            </div>
          </div>

          <FormItem label="Товч танилцуулга"><Input v-model="newPerson.taskDesc" type="textarea" :rows="2" /></FormItem>

          <FormItem>
            <Divider class="lh-1">Холбоо барих мэдээлэл</Divider>
          </FormItem>
          <FormItem label="Утасны дугаар"><Input v-model="newPerson.mobile" /></FormItem>
          <FormItem label="И-мэйл"><Input v-model="newPerson.st2" /></FormItem>
          <FormItem label="Хаяг"><Input v-model="newPerson.address" type="textarea" :rows="2" /></FormItem>
          <FormItem label="Байршил">
            <loc-type-cascader
                :id.sync="newPerson.locTypeId3"
                v-model="newPerson.locTypeId3"
                :getParentType="true"
                :checkStrictly="true"
                locTypekey="stptpCRMLocation"
                :disabled="false"
                disableAdd
              />
          </FormItem>
          <FormItem label="Холбоо барих боломжгүй үед холбоо барих төсөлд оролцогч">
            <Input v-model="newPerson.langCode" />
          </FormItem>
        </Form>
        <div class="text-center mg-t-10">
          <a @click="chooseNewPerson()" class="btn btn-success">Хадгалах</a>
        </div>
      </template>

      <template v-if="radio=='3'">
        <Form label-position="left" label-width="150px">
          <FormItem label="Байгууллагын нэр">
            <Input v-model="newOrg.name" />
          </FormItem>
          <FormItem>
            <Divider class="lh-1">Холбоо барих мэдээлэл</Divider>
          </FormItem>
          <FormItem label="Утасны дугаар"><Input v-model="newOrg.cphone" /></FormItem>
          <FormItem label="И-мэйл"><Input v-model="newOrg.cmail" /></FormItem>
          <FormItem label="Захирлын нэр"><Input v-model="newOrg.cname" /></FormItem>
          <FormItem label="Захирлын утас"><Input v-model="newOrg.cmobile" /></FormItem>
          <FormItem label="Хаяг"><Input v-model="newOrg.caddress" type="textarea" :rows="2" /></FormItem>
          <FormItem label="Холбоо барих боломжгүй үед холбоо барих төсөлд оролцогч"><Input v-model="newOrg.langCode" /></FormItem>
          <!-- <FormItem label="Байршил">
            <loc-type-cascader
                :id.sync="newOrg.location"
                v-model="newOrg.location"
                :getParentType="true"
                :checkStrictly="true"
                locTypekey="stptpCRMLocation"
                :disabled="false"
                disableAdd
              />
          </FormItem> -->
          <FormItem >
            <Divider class="lh-1">Бусад</Divider>
          </FormItem>
          <FormItem label="Байгуулагдсан огноо">
            <DatePicker
              v-model="newOrg.d1"
              type="date"
              placeholder="Select date"
              style="width: 100%"
              :format="'yyyy-MM-dd'"
              :value-format="'yyyy-MM-dd'"
            ></DatePicker>
          </FormItem>
          <FormItem label="Товч танилцуулга"><Input v-model="newOrg.taskDesc" type="textarea" :rows="2" /></FormItem>
          <FormItem label="Лого">
            <simple-uploader
                
                :propObjectId="6"
                :propObjectTypeId="6"
                @on-success="fileUploaded"
                class="wd-100 v4upldr"
                propAccept="image/png, image/jpeg, image/jpg, image/bmp"
              >
                <div slot="trigger" class="wd-100 ht-100 rounded-circle">
                  <a
                    v-if="
                    newOrg.defaultAttachmentId == 0 ||
                    newOrg.defaultAttachmentId == null
                    "
                    class="dropdown-item"
                    >Энд дарж зураг оруулна уу.</a
                  >
                  <div v-else class="pos-relative">
                    <div class="">
                      <img :src="`${newOrg.uploadedUrl}`" class="rounded-circle wd-100 ht-100" alt />
                    </div>
                    <div class="pos-absolute l-35 b-5 btn btn-icon btn-xs btn-primary rounded-circle">
                        <feather type="camera" class="tx-white"></feather>
                    </div>
                  </div>
                </div>
              </simple-uploader>
          </FormItem>
        </Form>
        <div class="text-center mg-t-10">
          <a @click="chooseNewOrg2()" class="btn btn-success">Хадгалах</a>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import { request } from "@/api/all";

import "element-ui/lib/theme-chalk/index.css";
import { Notification, Form, FormItem, Input, Button, Divider, Tabs, TabPane, Radio, DatePicker, Checkbox } from "element-ui";

import { hasOneOf } from "@/libs/tools";

export default {
  components: {
    Form, FormItem, Input, Button , Divider, Tabs, TabPane, Radio, DatePicker,Checkbox,
    coreList: () => ({
      component: import("@/views/apps/vet-med/list.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    simpleUploader: () => ({
      component: import("@/components/modules/media/simpleUploader.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    locTypeCascader: () => ({
      component: import("@/components/task/edit/components/locTypeCascader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  props: {
    mode: {
      type: Number,
      default: () => 50
    },
    prmsProp: {
      type: Object,
      default: () => {}
    },
    objectTypeId: {
      type: String,
      default: () => "0"
    },
    fieldName: {
      type: String,
      default: () => "0"
    },
    selectedId: {
      type: Number,
      default: () => null
    },
    parentTaskId: {
      type: Number,
      default: () => null
    },
    boxChooser: {
      type: Boolean,
      default: () => false
    },
    sidebarWidth: {
      type: String,
      default: () => "100%"
    },
    fld:{
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    radio: '1',
    activeName: 'first',
    showSidebar: false,
    prms: {},
    finderShow: false,
    taskModel: {},
    loading: true,
    finderKey: 0,
    tasks: [],
    project: {},
    textSearch: '',
    newOrg:{
      id: null,
      name: null,
      regno: null,

      type: null,

      cphone: null,
      cmail: null,
      cname: null,
      cmobile: null,
      caddress: null,

      fetched: false,
      langCode: null,
      location: null,

      d1: null,
      isTender: null,
      taskDesc: null,
      defaultAttachmentId: null,
      uploadedUrl: null,      

      modal: false
    },
    newPerson:{
      taskEn: null, //ovog
      task: '', //ner
      prefix: '', //regno
      locTypeId: 33797, //huvi hvn
      address: null,
      st2: null, //mail
      mobile: null, //utas
      taskDesc: null,
      locTypeId3: null,
      langCode: null
    },
  }),
  computed: {
    tasksFilter: function() {
        var textSearch = this.textSearch;
        return this.tasks.filter(function(el) {
            return el.task.toLowerCase().indexOf(textSearch.toLowerCase()) !== -1;
        });
    }
  },
  mounted() {
    let prjs = this.$store.state.app.groupDefaultProjects.filter(
      (x) => x.objectTypeId == this.objectTypeId
    );
    if (prjs != undefined && prjs.length) {
      this.project= prjs[0];
    }
    if (this.selectedId != null && this.selectedId != 0) {
      request({
        params: { id: this.selectedId },
        api: { url: "task/getInherited", method: "get" },
        store: this.$store
      }).then(res => {
        if (res != false) {
          //this.taskModel = res.data.task;
          this.$emit("on-task-selected", res.data.task);
        }
      });
    }
  },
  methods: {
    fileUploaded(e) {
      this.newOrg.uploadedUrl = e.uploadedUrl;
      this.newOrg.defaultAttachmentId = e.uploadedAttachmentId;
    },
    //...mapActions(["handleLoading"]),
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    init() {
      this.toggleBodyClass("addClass", "dynamic-locker");

      let _data = {
        projectId: this.project.id,
        size: 10000,
        skip: 0,
        model: this.taskModel,
      };

      request({
        api: { method: "POST", url: "TaskCore/GetCoreList" },
        data: _data,
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if(res!=false){
          this.tasks= res.data.tasks;
          this.finderShow = true;
          //console.log('res', res);
        }
      });
      // this.finderShow = true;
      // this.prms.objectTypeId = parseInt(this.objectTypeId, 10);
      // this.prms.mode = this.mode;
      
      // if(this.fieldName!=undefined){
      //   this.prms.fieldName = this.fieldName;
      // }

      // this.showSidebar = true;
      // this.$nextTick(() => {
      //   //this.finderKey++;
      // });

      // this.prms.parentTaskId= this.parentTaskId;
    },
    emitNull() {
      //this.$emit("input", null);
      this.$emit("on-task-selected", null);
    },
    // hasPerr(perrArr) {
    //   return hasOneOf(perrArr, this.$store.state.user.access);
    // },
    // taskSelected(e) {
    //   //console.log('step #1 taskSelected=> ', e, e.task, e.objectTypeId);
    //   this.finderShow = false;
    //   this.$nextTick(() => {
    //     this.showSidebar = false;
    //     this.taskModel.task = e.obj.task;
    //     this.$emit("input", e.obj.id);
    //     this.$emit("on-task-selected", e.obj);
    //     this.$emit("on-finder-close");
    //   });
    // },
    // visibleChanged(e) {
    //   if (!e) {
    //     //Object.assign(this.$data, this.$options.data());
    //     this.finderShow = false;
    //     this.$nextTick(() => {
    //       this.$emit("on-finder-close");
    //       this.showSidebar = false;
    //     });
    //   }
    // },
    handleTask(task){
      this.$emit("on-task-selected", task);
      this.finderShow = false;
    },
    showFinder() {
      this.init();
    },
    fetchNewOrg(){
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "CRM/CreateOrGetOrgIdByRegNo" },
        data: {regNo: this.newOrg.regno},
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if(res!=false) {
          this.newOrg.id= res.data.id;
          this.newOrg.name= res.data.name;
          this.newOrg.fetched= true;
          this.fetchAfter();
        } else {
          this.newOrg.id= null;
          this.newOrg.name= null;
          this.newOrg.fetched= false;
        }
      });
    },
    fetchAfter(){
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "Task/GetInherited" },
        params: {id: this.newOrg.id },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if(res!=false) {
          this.newOrg.task= res.data.task;

          //this.newOrg.type= res.data.task.locTypeId;
          this.newOrg.cphone= res.data.task.mobile; //# utas
          this.newOrg.cmail= res.data.task.st2; //# mail
          this.newOrg.cname= res.data.task.st3; //# zahiral ner          
          this.newOrg.cmobile= res.data.task.st4; //# zahiral utas
          this.newOrg.caddress= res.data.task.address; //# hayag
          this.newOrg.langCode= res.data.task.langCode;
          this.newOrg.location= res.data.task.locTypeId3;

          this.newOrg.d1= res.data.task.d1;
          this.newOrg.isTender= res.data.task.isTender;
          this.newOrg.taskDesc= res.data.task.taskDesc;
          this.newOrg.defaultAttachmentId= res.data.task.defaultAttachmentId;
          
          //console.log('dta', );
        }
      });
    },
    chooseNewPerson(){
      let _pid = 0;
      let prj = this.$store.state.app.groupDefaultProjects.filter(
        (x) => x.objectTypeId == parseInt(154, 10)
      );
      if (prj.length > 0) _pid = prj[0].id;
      //console.log('get inherited', _pid, this.$store.state.user.userInfo.profileId);
      
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "Task/GetInherited" },
        params: {
          id: 0,
          objectTypeId: 154,
          parentId: 0,
          projectId: _pid,
          boxId: 0,
          userId: this.$store.state.user.userInfo.userId,
        },
        store: this.$store,
      }).then((resi) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if(resi!=false){
          let _mdlobj= resi.data.task;
          
          _mdlobj.taskEn= this.newPerson.taskEn;
          _mdlobj.task= this.newPerson.task;
          _mdlobj.prefix= this.newPerson.prefix;
          _mdlobj.locTypeId= this.newPerson.locTypeId;
          _mdlobj.address= this.newPerson.address;
          _mdlobj.st2= this.newPerson.st2;
          _mdlobj.mobile= this.newPerson.mobile;

          _mdlobj.taskDesc= this.newPerson.taskDesc;
          _mdlobj.locTypeId3= this.newPerson.locTypeId3;
          _mdlobj.langCode= this.newPerson.langCode;

          let _errs=[];

          if(_mdlobj.taskEn==null || _mdlobj.taskEn==''){ _errs.push('Овог бичнэ үү'); }
          if(_mdlobj.task==null || _mdlobj.task==''){ _errs.push('Нэр бичнэ үү'); }
          if(_mdlobj.prefix==null || _mdlobj.prefix==''){ _errs.push('Иргэний бүртгэлийн дугаар бичнэ үү'); }
          if(_mdlobj.taskDesc==null || _mdlobj.taskDesc==''){ _errs.push('Товч танилцуулга бичнэ үү'); }

          if(_mdlobj.mobile==null || _mdlobj.mobile==''){ _errs.push('Утасны дугаар бичнэ үү'); }
          if(_mdlobj.st2==null || _mdlobj.st2==''){ _errs.push('И-мэйл бичнэ үү'); }
          if(_mdlobj.address==null || _mdlobj.address==''){ _errs.push('Хаяг бичнэ үү'); }
          if(_mdlobj.locTypeId3==null || _mdlobj.locTypeId3<0){ _errs.push('Байршил сонгоно уу'); }
          if(_mdlobj.langCode==null || _mdlobj.langCode==''){ _errs.push('Холбоо барих боломжгүй үед холбоо барих төсөлд оролцогч бичнэ үү'); }
          

          if(_errs.length){
            Notification.warning({
              message: `${_errs[0]}`,
              duration: 5000,
            });
          }else{
            this.toggleBodyClass("addClass", "dynamic-locker");
            request({
              api: { method: "POST", url: "Task/PostInherited" },
              data: { model: _mdlobj },
              store: this.$store,
            }).then((res) => {
              this.toggleBodyClass("removeClass", "dynamic-locker");
              if(res!=false) {
                //console.log('res', res);
                this.$emit("on-task-selected", {id: res.taskId, task: this.newPerson.task });
                this.newOrg.modal = false;
              }
            });
          }
        }
      });
    },
    chooseNewOrg2(){
      let _pid = 0;
      let prj = this.$store.state.app.groupDefaultProjects.filter(
        (x) => x.objectTypeId == parseInt(154, 10)
      );
      if (prj.length > 0) _pid = prj[0].id;

      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "Task/GetInherited" },
        params: {
          id: 0,
          objectTypeId: 154,
          parentId: 0,
          projectId: _pid,
          boxId: 0,
          userId: this.$store.state.user.userInfo.userId,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if(res!=false){
          let _mdlobj= res.data.task;

          _mdlobj.task= this.newOrg.name;
          _mdlobj.mobile= this.newOrg.cphone;
          _mdlobj.st2=this.newOrg.cmail;
          _mdlobj.st3=this.newOrg.cname;
          _mdlobj.st4=this.newOrg.cmobile;
          _mdlobj.address=this.newOrg.caddress;
          _mdlobj.langCode=this.newOrg.langCode;
          _mdlobj.d1=this.newOrg.d1;
          _mdlobj.taskDesc=this.newOrg.taskDesc;
          _mdlobj.defaultAttachmentId=this.newOrg.defaultAttachmentId;
 
          let _errs=[];

          if(_mdlobj.task==null || _mdlobj.task==''){ _errs.push('Нэр бичнэ үү'); }
          if(_mdlobj.taskDesc==null || _mdlobj.taskDesc==''){ _errs.push('Товч танилцуулга бичнэ үү'); }

          if(_mdlobj.mobile==null || _mdlobj.mobile==''){ _errs.push('Утасны дугаар бичнэ үү'); }
          if(_mdlobj.st2==null || _mdlobj.st2==''){ _errs.push('И-мэйл бичнэ үү'); }
          if(_mdlobj.address==null || _mdlobj.address==''){ _errs.push('Хаяг бичнэ үү'); }
          if(_mdlobj.langCode==null || _mdlobj.langCode==''){ _errs.push('Холбоо барих боломжгүй үед холбоо барих төсөлд оролцогч бичнэ үү'); }
          
          if(_errs.length){
            Notification.warning({
              message: `${_errs[0]}`,
              duration: 5000,
            });
          }else{
            this.toggleBodyClass("addClass", "dynamic-locker");
            request({
              api: { method: "POST", url: "Task/PostInherited" },
              data: { model: _mdlobj },
              store: this.$store,
            }).then((res) => {
              this.toggleBodyClass("removeClass", "dynamic-locker");
              if(res!=false) {
                //console.log('res', res);
                this.$emit("on-task-selected", {id: res.taskId, task: this.newOrg.task });
                this.newOrg.modal = false;
              }
            });
          }
        }
      });
    },
    chooseNewOrg(){
      // if(this.newOrg.type != this.newOrg.task.locTypeId
      // || this.newOrg.cphone != this.newOrg.task.mobile
      // || this.newOrg.cmail != this.newOrg.task.st2
      // || this.newOrg.cname != this.newOrg.task.st3
      // || this.newOrg.cmobile != this.newOrg.task.st4
      // || this.newOrg.caddress != this.newOrg.task.address
      // || this.newOrg.langCode != this.newOrg.task.langCode
      // || this.newOrg.location != this.newOrg.task.locTypeId3

      // || this.newOrg.d1 != this.newOrg.task.d1
      // || this.newOrg.isTender != this.newOrg.task.isTender
      // || this.newOrg.taskDesc != this.newOrg.task.taskDesc
      // || this.newOrg.defaultAttachmentId != this.newOrg.task.defaultAttachmentId
      // ){
        this.newOrg.task.locTypeId= this.newOrg.type;
        this.newOrg.task.mobile= this.newOrg.cphone;
        this.newOrg.task.st2= this.newOrg.cmail;
        this.newOrg.task.st3= this.newOrg.cname;
        this.newOrg.task.st4= this.newOrg.cmobile;
        this.newOrg.task.address= this.newOrg.caddress;
        this.newOrg.task.langCode= this.newOrg.langCode;
        this.newOrg.task.locTypeId3= this.newOrg.location;

        this.newOrg.task.d1= this.newOrg.d1;
        this.newOrg.task.isTender= this.newOrg.isTender;
        this.newOrg.task.taskDesc= this.newOrg.taskDesc;
        this.newOrg.task.defaultAttachmentId= this.newOrg.defaultAttachmentId;

        let _errs=[];

        if(this.newOrg.task.taskDesc==null || this.newOrg.task.taskDesc==''){ _errs.push('Товч танилцуулга бичнэ үү'); }

        if(this.newOrg.task.mobile==null || this.newOrg.task.mobile==''){ _errs.push('Утасны дугаар бичнэ үү'); }
        if(this.newOrg.task.st2==null || this.newOrg.task.st2==''){ _errs.push('И-мэйл бичнэ үү'); }
        if(this.newOrg.task.address==null || this.newOrg.task.address==''){ _errs.push('Хаяг бичнэ үү'); }
        if(this.newOrg.task.locTypeId3==null || this.newOrg.task.locTypeId3<0){ _errs.push('Байршил сонгоно уу'); }
        if(this.newOrg.task.langCode==null || this.newOrg.task.langCode==''){ _errs.push('Холбоо барих боломжгүй үед холбоо барих төсөлд оролцогч бичнэ үү'); }
        
        if(_errs.length){
            Notification.warning({
              message: `${_errs[0]}`,
              duration: 5000,
            });
          }else{
            this.toggleBodyClass("addClass", "dynamic-locker");
            request({
              api: { method: "POST", url: "Task/PostInherited" },
              data: { model: this.newOrg.task },
              store: this.$store,
            }).then((res) => {
              this.toggleBodyClass("removeClass", "dynamic-locker");
              if(res!=false) {
                this.newOrg.modal= false;
                this.$emit("on-task-selected", {id: this.newOrg.id, task: this.newOrg.name });
                this.finderShow = false;
              }
            });
          }
      // }else{
      //   this.newOrg.modal= false;
      //   this.$emit("on-task-selected", {id: this.newOrg.id, task: this.newOrg.name });
      //   this.finderShow = false;  
      // }
    },
    openNewOrg(){
      this.newOrg.modal= true;
      this.newOrg.id= null;
      this.newOrg.regno= null;
      this.newOrg.name= null;

      this.newOrg.cphone= null;
      this.newOrg.cname= null;
      this.newOrg.cmail= null;
      this.newOrg.cmobile= null;

      this.newOrg.fetched= false;
    },
  }
};
</script>
